import { FaInstagram, FaFacebookF, FaLinkedinIn, FaEnvelope, FaPhone, FaMapMarkerAlt } from "react-icons/fa";
import { Link } from "react-router-dom";

function Footer() {
  return (
    <footer className="bg-[#4299f5] text-white px-3 sm:px-4 lg:px-6 py-8 sm:py-10 lg:py-12 text-sm mt-10" style={{fontFamily: 'Montserrat, sans-serif'}}>
      <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
        {/* Company Info */}
        <div className="flex flex-col items-center sm:items-start">
          <div className="flex items-center gap-2 sm:gap-3 mb-3">
            <img src="/images/trivanalogo.jpg" alt="Trivana Logo" className="h-10 w-10 sm:h-12 sm:w-12 object-contain rounded" />
            <div>
              <h2 className="text-xl sm:text-2xl font-bold text-white" style={{fontFamily: 'Montserrat, sans-serif', fontWeight: 700}}>
                Trivana Hospitality
              </h2>
            </div>
          </div>
          <p className="text-xs sm:text-sm leading-relaxed text-white mb-3 sm:mb-4 text-center sm:text-left">
            Transform your hospitality business with intelligent solutions designed for modern hotels and restaurants.
          </p>
          <div className="flex space-x-2 sm:space-x-3">
            <a
              href="https://www.facebook.com/profile.php?id=61574583771198"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
              className="w-9 h-9 sm:w-10 sm:h-10 rounded-full bg-[#F5E6D3] flex items-center justify-center hover:bg-white transition-colors duration-200"
            >
              <FaFacebookF className="text-[#1e40af] text-base sm:text-lg" />
            </a>
            <a
              href="https://www.instagram.com/trivanahospitality"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
              className="w-9 h-9 sm:w-10 sm:h-10 rounded-full bg-[#F5E6D3] flex items-center justify-center hover:bg-white transition-colors duration-200"
            >
              <FaInstagram className="text-[#1e40af] text-base sm:text-lg" />
            </a>
          </div>
        </div>

        {/* Quick Links */}
        <div className="flex flex-col items-center sm:items-start">
          <h3 className="text-base sm:text-lg font-bold mb-3 sm:mb-4 text-white">Explore</h3>
          <ul className="space-y-2 sm:space-y-2.5 text-sm sm:text-base text-center sm:text-left">
            <li>
              <Link to="/" onClick={() => window.scrollTo(0, 0)} className="text-white hover:text-white/70 transition-colors duration-200">
                Home
              </Link>
            </li>
            <li>
              <Link to="/features" onClick={() => window.scrollTo(0, 0)} className="text-white hover:text-white/70 transition-colors duration-200">
                Features
              </Link>
            </li>
            <li>
              <Link to="/pricing" onClick={() => window.scrollTo(0, 0)} className="text-white hover:text-white/70 transition-colors duration-200">
                Pricing
              </Link>
            </li>
            <li>
              <Link to="/about" onClick={() => window.scrollTo(0, 0)} className="text-white hover:text-white/70 transition-colors duration-200">
                About
              </Link>
            </li>
            <li>
              <Link to="/team" onClick={() => window.scrollTo(0, 0)} className="text-white hover:text-white/70 transition-colors duration-200">
                Team
              </Link>
            </li>
            <li>
              <Link to="/careers" onClick={() => window.scrollTo(0, 0)} className="text-white hover:text-white/70 transition-colors duration-200">
                Careers
              </Link>
            </li>
            <li>
              <Link to="/contact" onClick={() => window.scrollTo(0, 0)} className="text-white hover:text-white/70 transition-colors duration-200">
                Contact
              </Link>
            </li>
          </ul>
        </div>

        {/* Resources */}
        <div className="flex flex-col items-center sm:items-start">
          <h3 className="text-base sm:text-lg font-bold mb-3 sm:mb-4 text-white">Help</h3>
          <ul className="space-y-2 sm:space-y-2.5 text-sm sm:text-base text-center sm:text-left">
            <li>
              <Link to="/privacy" onClick={() => window.scrollTo(0, 0)} className="text-white hover:text-white/70 transition-colors duration-200">
                Privacy Policy
              </Link>
            </li>
            <li>
              <Link to="/support" onClick={() => window.scrollTo(0, 0)} className="text-white hover:text-white/70 transition-colors duration-200">
                Support
              </Link>
            </li>
            <li>
              <Link to="/terms" onClick={() => window.scrollTo(0, 0)} className="text-white hover:text-white/70 transition-colors duration-200">
                Terms and Conditions
              </Link>
            </li>
            <li>
            </li>
          </ul>
        </div>

        {/* Contact */}
        <div className="flex flex-col items-center sm:items-start">
          <h3 className="text-base sm:text-lg font-bold mb-3 sm:mb-4 text-white">Contact</h3>
          <ul className="space-y-2 sm:space-y-2.5 text-sm sm:text-base">
            <li className="flex items-start gap-2">
              <FaMapMarkerAlt className="text-white mt-0.5 sm:mt-1 flex-shrink-0 text-sm" />
              <span className="text-white">Sonegiri Kua, Bikaner, Rajasthan</span>
            </li>
            <li className="flex items-start gap-2">
              <FaPhone className="text-white mt-0.5 sm:mt-1 flex-shrink-0 text-sm" />
              <div className="flex flex-col">
                <a href="tel:+919257734350" className="text-white hover:text-white/70 transition">
                  +91 9257734350
                </a>
              </div>
            </li>
            <li className="flex items-start gap-2">
              <FaEnvelope className="text-white mt-0.5 sm:mt-1 flex-shrink-0 text-sm" />
              <a href="mailto:info@trivanahospitality.com" className="text-white hover:text-white/70 transition break-all">
                trivanahospitality@gmail.com
              </a>
            </li>
          </ul>
        </div>
      </div>

      {/* Bottom Section */}
      <div className="mt-8 sm:mt-10 lg:mt-12 pt-6 sm:pt-8 border-t border-white/20">
        <div className="max-w-7xl mx-auto">
          <div className="text-center text-xs sm:text-sm text-white">
            © 2026 TRIVANA HOSPITALITY LLP. ALL RIGHTS RESERVED.
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
